export default __webpack_public_path__ + "static/media/arrow-rounded-down-9x6.77aaf04f.svg";